import React from 'react';
import {Menu, Transition} from "@headlessui/react";
import {EllipsisVerticalIcon} from "@heroicons/react/20/solid";

export default function NavResponsiveMenu({allTabs, onTabChange, lastVisibleTab, translate}) {

    const menuItems = allTabs.filter((it, i) => i > lastVisibleTab && !it.current).map(it => { // current item is no longer rendering
        return (
            <Menu.Item key={it.name}>
                {({active}) => (
                    <span
                        onClick={() => onTabChange(it.resource)}
                        className={`cursor-pointer py-2 px-4 flex items-center ${active ? 'bg-tm-gray-100 text-primary' : it.current ? " text-primary" : " text-tm-gray-700"} ${!!it.current && " font-bold"}`}
                    >
                        {translate("tab." + it.name)}
                </span>
                )}
            </Menu.Item>
        )
    })

    return (
        <Menu>
            {({open}) => (
                <React.Fragment>
                    <Menu.Button
                        className="absolute text-inverse w-8 h-8 p-0 flex justify-center items-center right-0 top-1 hover:bg-tm-gray-100 rounded-full focus:outline-hidden focus:ring-2 ring-primary-tint cursor-pointer">
                        <EllipsisVerticalIcon className="w-5 h-5 text-primary"/>
                    </Menu.Button>

                    <Transition
                        show={open}
                    >
                        <Menu.Items
                            className="z-40 absolute right-0 top-12 w-56 py-2 origin-top-right bg-inverse rounded-md shadow-lg ring-1 ring-black/10 focus:outline-hidden border border-tm-gray-200"
                        >
                            {menuItems}
                            {/*<div*/}
                            {/*    className="absolute w-2 h-2 -top-1 right-3 border-l border-t transform rotate-45 border-solid border-tm-gray-200 bg-inverse -z-1"/>*/}
                        </Menu.Items>
                    </Transition>
                </React.Fragment>
            )}
        </Menu>
    )
}
